import { t } from 'i18next';

export const getLabelOptions = () => {
  return [
    {
      value: 'percentage',
      text: t('percentage'),
    },
    {
      value: 'number',
      text: t('values'),
    },
    {
      value: 'both',
      text: t('both'),
    },
  ];
};
